import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { reqData } from "../../js/server";
import ContentLoader from "react-content-loader";

function SubMenu(props) {
    const dispatch = useDispatch();
    let userinfo = JSON.parse(localStorage.getItem("userinfo"));
    const [banners, setBanners] = useState([]);
    const [usertype, setUsertype] = useState(userinfo?.usertype ?? "");

    const fetchBannerData = () => {
        const jsonData = {
            servicename: "BannerList",
        };

        dispatch({ type: "loadingChange", payload: true });
        reqData(jsonData)
            .then((res) => {
                if (res.data.result === "OK") {
                    setBanners(res.data.jsonData);
                } else {
                    alert(res.data.msg);
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                dispatch({ type: "loadingChange", payload: false });
            });
    };

    const setMenu = () => {
        switch (props.id) {
            case "admin":
                return (
                    <div className="sidebar-widget category mb-3">
                        <h5 className="mb-4">관리자 메뉴</h5>

                        <ul className="list-unstyled">
                            <li className="align-items-center">
                                <Link to="/Admin/MemberList">회원관리</Link>
                            </li>
                            <li className="align-items-center">
                                <Link to="/Admin/BannerMgr">배너관리</Link>
                            </li>
                        </ul>
                    </div>
                );
            case "intro":
                return (
                    <div className="sidebar-widget category mb-3">
                        <h5 className="mb-4">조합소개</h5>

                        <ul className="list-unstyled">
                            <li className="align-items-center">
                                <Link to="/Greetings">이사장 인사말</Link>
                            </li>
                            <li className="align-items-center">
                                <Link to="/History">연혁</Link>
                            </li>
                            <li className="align-items-center">
                                <Link to="/Articles">조합정관 및 사업자윤리강령</Link>
                            </li>
                            <li className="align-items-center">
                                <Link to="/Directions">찾아오시는 길</Link>
                            </li>
                        </ul>
                    </div>
                );
            case "docu":
                return (
                    <div className="sidebar-widget category mb-3">
                        <h5 className="mb-4">문서함</h5>

                        <ul className="list-unstyled">
                            <li className="align-items-center">
                                <a
                                    href="#!"
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=docu")
                                    }
                                >
                                    문서함
                                </a>
                            </li>
                        </ul>
                    </div>
                );
            case "laws":
                return (
                    <div className="sidebar-widget category mb-3">
                        <h5 className="mb-4">자동차관련법규</h5>

                        <ul className="list-unstyled">
                            <li className="align-items-center">
                                <a
                                    href="#!"
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=laws")
                                    }
                                >
                                    자동차관련법규
                                </a>
                            </li>
                        </ul>
                    </div>
                );
            case "unionMem":
                return (
                    <div className="sidebar-widget category mb-3">
                        <h5 className="mb-4">정비업체현황</h5>

                        <ul className="list-unstyled">
                            <li className="align-items-center">
                                <a
                                    href="#!"
                                    onClick={() => (window.location.href = "/UnionMem")}
                                >
                                    정비업체현황
                                </a>
                            </li>
                            <li className="align-items-center">
                                <a
                                    href="#!"
                                    onClick={() =>
                                        (window.location.href = "/UnionMem?testkind=1")
                                    }
                                >
                                    종합검사 업체안내
                                </a>
                            </li>
                            <li className="align-items-center">
                                <a
                                    href="#!"
                                    onClick={() =>
                                        (window.location.href = "/UnionMem?testkind=2")
                                    }
                                >
                                    정기검사 업체안내
                                </a>
                            </li>
                        </ul>
                    </div>
                );
            case "pds01":
            case "pds02":
            case "pds03":
            case "pds04":
            case "pds05":
            case "pds06":
            case "pds08":
                return (
                    <div className="sidebar-widget category mb-3">
                        <h5 className="mb-4">자료실</h5>

                        <ul className="list-unstyled">
                            <li className="align-items-center">
                                <a
                                    href="#!"
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=pds02")
                                    }
                                >
                                    정비업무 자료실
                                </a>
                            </li>

                            <li className="align-items-center">
                                <a
                                    href="#!"
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=pds06")
                                    }
                                >
                                    검사업무 자료실
                                </a>
                            </li>

                            <li className="align-items-center">
                                <a
                                    href="#!"
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=pds01")
                                    }
                                >
                                    산업안전보건 자료실
                                </a>
                            </li>

                            <li className="align-items-center">
                                <a
                                    href="#!"
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=pds05")
                                    }
                                >
                                    조합임원 자료실
                                </a>
                            </li>

                            <li className="align-items-center">
                                <a
                                    href="#!"
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=pds04")
                                    }
                                >
                                    서식 자료실
                                </a>
                            </li>

                            <li className="align-items-center">
                                <a
                                    href="#!"
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=pds03")
                                    }
                                >
                                    기타 자료실
                                </a>
                            </li>
                            {
                                usertype === "0" || usertype === "1"
                                    ? (
                                        <li className="align-items-center">
                                            <a
                                                href="#!"
                                                onClick={() =>
                                                    (window.location.href = "/ABoardList?kind=pds08")
                                                }
                                            >
                                                조합자료실
                                            </a>
                                        </li>
                                    ) : null
                            }
                        </ul>
                    </div>
                );
            case "free":
            case "schedule":
            case "gallery":
            case "joboffer":
            case "jobsearch":
            case "pds07":
                return (
                    <div className="sidebar-widget category mb-3">
                        <h5 className="mb-4">정보광장</h5>

                        <ul className="list-unstyled">

                            <li className="align-items-center">
                                <a
                                    href="#!"
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=pds07")
                                    }
                                >
                                    교육일정 및 신청안내
                                </a>
                            </li>
                            <li className="align-items-center">
                                <a
                                    href="#!"
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=free")
                                    }
                                >
                                    자유게시판
                                </a>
                            </li>
                            <li className="align-items-center">
                                <a
                                    href="#!"
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=schedule")
                                    }
                                >
                                    이사장 동정
                                </a>
                            </li>
                            <li className="align-items-center">
                                <a
                                    href="#!"
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=gallery")
                                    }
                                >
                                    포토갤러리
                                </a>
                            </li>
                            <li className="align-items-center">
                                <a
                                    href="#!"
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=joboffer")
                                    }
                                >
                                    구인정보
                                </a>
                            </li>
                            <li className="align-items-center">
                                <a
                                    href="#!"
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=jobsearch")
                                    }
                                >
                                    구직정보
                                </a>
                            </li>
                        </ul>
                    </div>
                );
            case "info":
                return (
                    <div className="sidebar-widget category mb-3">
                        <h5 className="mb-4">공지사항</h5>

                        <ul className="list-unstyled">
                            <li className="align-items-center">
                                <a
                                    href="#!"
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=info")
                                    }
                                >
                                    공지사항
                                </a>
                            </li>
                        </ul>
                    </div>
                );
            case "news":
                return (
                    <div className="sidebar-widget category mb-3">
                        <h5 className="mb-4">자동차정비뉴스</h5>

                        <ul className="list-unstyled">
                            <li className="align-items-center">
                                <a
                                    href="#!"
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=news")
                                    }
                                >
                                    자동차정비뉴스
                                </a>
                            </li>
                        </ul>
                    </div>
                );
            case "event":
                return (
                    <div className="sidebar-widget category mb-3">
                        <h5 className="mb-4">경조사</h5>

                        <ul className="list-unstyled">
                            <li className="align-items-center">
                                <a
                                    href="#!"
                                    onClick={() =>
                                        (window.location.href = "/ABoardList?kind=event")
                                    }
                                >
                                    경조사
                                </a>
                            </li>
                        </ul>
                    </div>
                );
            default:
                return (
                    <div className="sidebar-widget category mb-3">
                        <ContentLoader
                            speed={2}
                            width={600}
                            height={160}
                            viewBox="0 0 600 160"
                            backgroundColor="#f3f3f3"
                            foregroundColor="#ecebeb"
                        >
                            <rect x="1" y="3" rx="0" ry="0" width="160" height="35" />
                            <rect x="5" y="61" rx="0" ry="0" width="140" height="25" />
                            <rect x="5" y="96" rx="0" ry="0" width="140" height="25" />
                            <rect x="5" y="131" rx="0" ry="0" width="140" height="25" />
                        </ContentLoader>
                    </div>
                );
        }
    };

    useEffect(
        () => {
            //Partners Banner 불러오기
            fetchBannerData();
        },
        // eslint-disable-next-line
        []
    );

    return (
        <div className="col-lg-3">
            <div className="sidebar-wrap pl-lg-4 mt-5 mt-lg-0">
                {setMenu()}

                <div className="sidebar-widget mb-3">
                    <h5 className="mb-4">파트너사</h5>

                    <div className="row clients-logo">
                        {banners.map((banner, idx) => (
                            <div className="col-12" key={idx}>
                                <div className="client-thumb2">
                                    {banner.bn_url.length > 8 ? (
                                        <a href={banner.bn_url} target="_blank" rel="noreferrer">
                                            <img
                                                src={banner.file_url}
                                                alt={banner.file_url}
                                                className="img-fluid2"
                                            />
                                        </a>
                                    ) : (
                                        <img
                                            src={banner.file_url}
                                            alt={banner.file_url}
                                            className="img-fluid2"
                                        />
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="sidebar-widget schedule-widget mb-3">
                    <h5 className="mb-4">연락처</h5>

                    <div className="sidebar-contatct-info mt-4">
                        <p className="mb-0">전화</p>
                        <h3>033)254-4825</h3>
                    </div>

                    <div className="sidebar-contatct-info mt-4">
                        <p className="mb-0">팩스</p>
                        <h3>033)257-0741</h3>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SubMenu;
